import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import {
  IMAGE_PATH,
  itemCount,
  COMMON_FAIL_MESSAGE,
  BASE_IMAGES_URL,
} from "Constants";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import FormBuilder from "../../../tickets/components/form-builder/form-builder";
import { showError, showSuccess } from "ReduxErrorBar";
import { updateFomeName, updateFormList } from "FormBuilderAction";
import InlineCropper from "InlineCropper";
import {
  addProposal,
  fetchProposalStep,
  updateProposal,
  fetchSingleProposal,
  editProposal,
  _uploadBanner,
  fetchProposal,
} from "ProposalAction";
import LocaleStrings from "Languages";
import { randomstring } from "randomstring-js";
import { maxLengthObjectFc } from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
var MAXLENOBJ = {};
class EditProposal extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, imagePreviewUrl: "" };
    this.onImageSave = this.onImageSave.bind(this);
    this.cropperRef = React.createRef();
  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img });
    //this.props.updateExhibitorImage(img);
  };

  onImageChange = (imageAvailable) => {
    if (imageAvailable !== undefined) this.setState({ imageAvailable });
  };

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
    if (
      this.props.initialValues &&
      this.props.initialValues.proposalid &&
      this.props.initialValues.event_forms_by_formid &&
      this.props.initialValues.event_forms_by_formid.formname
    ) {
      //console.log("this.props.initialValues", this.props.initialValues);
      let formname = this.props.initialValues.event_forms_by_formid.formname;
      var newObj = JSON.parse(
        this.props.initialValues.event_forms_by_formid.formjson
      );
      this.props.updateFomeName(formname); // Form Name
      this.props.updateFormList(newObj, this.props.oldKeys, "samearray");
    }
  }

  onSubmitForm = (values) => {
    if (values.proposalid) {
      let data = {};
      data.proposalid = values.proposalid;
      data.proposal_name = values.proposal_name;
      data.proposaldesc = values.proposaldesc;
      data.category = values.category;

      if (this.state.imagePreviewUrl) {
        this.setState({ loading: true });
        let randStr = `${randomstring(32)}.png`;
        data.proposal_image = `eventify/${this.props.session.eventid}/proposals/images/${randStr}`;
        this.props._uploadBanner(
          this.props.session,
          this.state.imagePreviewUrl,
          `images/${randStr}`,
          (feedback) => {
            if (feedback.success === 1) {
              this.props.updateProposal(
                this.props.session,
                data,
                (response) => {
                  if (response.success === 0) {
                    this.setState({ loading: false });
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  } else {
                    this.props.fetchSingleProposal(
                      this.props.session,
                      values.proposalid,
                      (response) => {
                        let proposalList = response.data;
                        this.props.editProposal(proposalList[0]);
                      }
                    );

                    this.setState({ loading: false });
                    this.props.showSuccess(
                      LocaleStrings.proposal_info_updated_success
                    );
                    this.props.fetchProposalStep("step_2");
                    this.props.fetchProposal(
                      this.props.session,
                      (callback) => {}
                    );
                  }
                }
              );
            } else {
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            }
          }
        );
      } else {
        this.props.updateProposal(this.props.session, data, (response) => {
          if (response.success === 0) {
            this.setState({ loading: false });
            this.props.showError(COMMON_FAIL_MESSAGE);
          } else {
            this.props.fetchSingleProposal(
              this.props.session,
              values.proposalid,
              (response) => {
                let proposalList = response.data;
                this.props.editProposal(proposalList[0]);
              }
            );
            this.setState({ loading: false });
            this.props.showSuccess(LocaleStrings.proposal_info_updated_success);
            this.props.fetchProposalStep("step_2");
            this.props.fetchProposal(this.props.session, (callback) => {});
          }
        });
      }
    }
  };

  renderCustomTextarea(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12 m-0 mb-5">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>{" "}
          {/* <span style={{ fontSize: 10 }}>
            (
            {
              LocaleStrings.tickets_ticket_form_label_ticket_description_extra_text
            }
            )
          </span> */}
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          <textarea
            className="form-control"
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            {...field.input}
            disabled={field.disabled}
            style={{ height: 75 }}
          ></textarea>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12 m-0 mb-5";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldTexts(field) {
    let charactersLeft = "";
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }

    var labelposition = field.labelposition;
    // debugger
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses} style={{ position: "relative" }}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.error ? field.meta.error : ""}
          </div>
          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      oldKeys,
      initialValues,
      editProposal,
      editMode,
    } = this.props;

    let { imagePreviewUrl } = this.state;

    if (initialValues) {
      imagePreviewUrl = initialValues.proposal_image
        ? `${BASE_IMAGES_URL}/${initialValues.proposal_image}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`
        : "";
    }

    return (
      <div>
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div
            className="col-md-8 mb-15"
            style={{ marginLeft: "-15px", fontWeight: "bold" }}
          >
            {/* *You must need to publish once after updating the data */}
          </div>
          <div className="row">
            <div className="col-md-7 mb-15" style={{ marginLeft: "-15px" }}>
              <Field
                name="proposal_name"
                label={LocaleStrings.proposal_name}
                placeholder={LocaleStrings.proposal_name}
                type="text"
                component={this.renderFieldText}
                mandatory="true"
                // disabled={this.props.editMode}
              />

              <div>
                <Field
                  name="proposaldesc"
                  label={LocaleStrings.proposal_description}
                  placeholder={LocaleStrings.proposal_description}
                  component={this.renderCustomTextarea}
                  mandatory="true"

                  // disabled={this.props.editMode}
                />
              </div>
              <div>
                <Field
                  name="category"
                  label={LocaleStrings.proposal_category}
                  placeholder={LocaleStrings.proposal_category}
                  type="text"
                  component={this.renderFieldTexts}
                  labelposition={LABEL_POSITION_TOP}
                  mandatory="false"
                  maxlength={MAXLENOBJ.category ? MAXLENOBJ.category : ""}
                  // disabled={this.props.editMode}
                />
              </div>
            </div>

            <div className="col-md-5 mb-15" style={{ marginLeft: "0px" }}>
              <div className="form-group  ">
                <label className="control-label-top col-sm-12 m-0 mb-5">
                  Banner
                </label>
                <div className="col-sm-12 col-sm-offset-0 imgPreview">
                  <InlineCropper
                    width={940}
                    height={445}
                    border={10}
                    onImageSave={this.onImageSave}
                    onImageChange={this.onImageChange}
                    imagepath={imagePreviewUrl}
                    ref={this.cropperRef}
                    callFrom="proposal"
                  />
                  <div className="" style={{ marginTop: "15px" }}>
                    {LocaleStrings.proposal_image_subtitle_info}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="form-group row">
            <label className="control-label-top col-sm-12">Image</label>
            <div className="col-sm-12 col-sm-offset-0 imgPreview">
              <div className="image-subtitle-info">
                {LocaleStrings.proposal_image_subtitle_info}
              </div>
            </div>
          </div> */}

          <div
            className="col-md-8"
            style={{ marginTop: "10px", marginLeft: "-22px" }}
          >
            <Button
              className="btn btn-custom-blue ml-10"
              bsStyle=""
              loading={this.state.loading}
              disabled={
                initialValues ? false : pristine || invalid || submitting
              }
              type="submit"
            >
              {LocaleStrings.proposal_form_button_continue}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('formName :: == ', state.formName);
  //console.log('oldKeys :: == ', state.formList);
  var initVals = {};
  if (state.updateProposal && state.updateProposal.proposalid) {
    initVals = state.updateProposal ? state.updateProposal : {};
  }

  return {
    session: state.session,
    oldKeys: state.formList,
    formName: state.formName,
    initialValues: initVals,
    editProposal: state.updateProposal,
    editMode: !_.isEmpty(state.updateProposal),
  };
}

function validate(values) {
  // console.log('values',values);
  var errors = {};
  var proposal_name = values["proposal_name"];
  var proposaldesc = values["proposaldesc"];

  if (!proposal_name) {
    errors["proposal_name"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!proposaldesc) {
    errors["proposaldesc"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }

  if (values["category"] && MAXLENOBJ) {
    if (values["category"].length > MAXLENOBJ.category) {
      errors["category"] = "Max character length is: " + MAXLENOBJ.category;
    }
  }

  return errors;
}

export default connect(mapStateToProps, {
  updateFomeName,
  updateFormList,
  showError,
  showSuccess,
  addProposal,
  fetchProposalStep,
  updateProposal,
  fetchSingleProposal,
  editProposal,
  _uploadBanner,
  fetchProposal,
})(
  reduxForm({
    validate,
    form: "ProposalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditProposal)
);
